import { useQuery } from '@tanstack/react-query';
import { StatusCode, getCustomerPeriodicities } from '@hungryroot/rest';

const timeLimit = 15 * 60 * 1000;

export function useCustomerPeriodicities(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['Customers', 'periodicities'],
    queryFn: async () => {
      const resp = await getCustomerPeriodicities();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
